// extracted by mini-css-extract-plugin
export default {"modal":"SignUpError_modal__jb0QU","container":"SignUpError_container__wiTrB","close":"SignUpError_close__mtvta"};